function getToastPlacement(position) {
  var _logical$dir;
  var dir = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ltr';
  if (!position) return;
  var logicals = {
    'top-start': {
      ltr: 'top-left',
      rtl: 'top-right'
    },
    'top-end': {
      ltr: 'top-right',
      rtl: 'top-left'
    },
    'bottom-start': {
      ltr: 'bottom-left',
      rtl: 'bottom-right'
    },
    'bottom-end': {
      ltr: 'bottom-right',
      rtl: 'bottom-left'
    }
  };

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  var logical = logicals[position];
  return (_logical$dir = logical === null || logical === void 0 ? void 0 : logical[dir]) !== null && _logical$dir !== void 0 ? _logical$dir : position;
}

export { getToastPlacement };
//# sourceMappingURL=toast.placement.esm.js.map
